import moment from "moment";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { AttachedCommunication } from "@/Common/Models/AttachedCommunication/AttachedCommunication";
import { AttachedCommunicationType } from "@/Common/Models/AttachedCommunication/AttachedCommunicationType";

interface IAttachedCommunicationsPopupProps {
    controlId: string;
    attachedCommunications: AttachedCommunication[];
    handleRedirect: (attachedCommunication: AttachedCommunication, context?: AttachedCommunicationType) => void;
    handleClose: () => void;
    leftPosition: number;
    topPosition: number;
    context?: AttachedCommunicationType;
    dataCy?: string;
}

class AttachedCommunicationsPopup extends BaseReactComponent<IAttachedCommunicationsPopupProps, null> {
    public componentDidMount(): void {
        super.setOverlay("AttachedCommunicationsPopup", { transparent: true, onClicked: () => this.handleClose() });
    }

    public render(): JSX.Element {
        const style: React.CSSProperties = {
            position: "absolute",
            left: this.props.leftPosition + "px",
            top: this.props.topPosition + "px"
        };

        let title: string;
        switch (this.props.context) {
            case AttachedCommunicationType.Recall:
                title = cacheStore.GetString("RecallLabel");
                break;
            case AttachedCommunicationType.Message:
                title = cacheStore.GetString("MessageLabel");
                break;
            case AttachedCommunicationType.Task:
                title = cacheStore.GetString("TaskLabel");
                break;
        }

        return (
            <div id={this.props.controlId} className="notes-modal" style={style}>
                <div className="notes-dropdown-content">
                    <h3>{title}</h3>
                    <div data-cy={this.props.dataCy}>
                        {this.renderList()}
                    </div>
                </div>
            </div>
        );
    }

    private renderList(): JSX.Element[] {
        return this.props.attachedCommunications?.map(ac => {
            let id = ac.IndividualMessageId ? ac.IndividualMessageId : ac.RecallId;
            return (
                <div key={id}>
                    <a onClick={() => this.props.handleRedirect(ac, this.props.context)}>
                        {!IsNullOrWhiteSpace(ac.StatusId) &&
                            <span>{cacheStore.GetLocalizedValueByLookupId(ac.StatusId)} - </span>
                        }
                        {this.props.context === AttachedCommunicationType.Message &&
                            <span>{cacheStore.GetString(ac.IsMessageRead ? "ReadLabel" : "NotReadLabel")} - </span>
                        }
                        {this.props.context === AttachedCommunicationType.Recall &&
                            <span>{cacheStore.GetString(ac.IsRecallCompleted ? "CompletedLabel" : "NotCompletedLabel")} - </span>
                        }
                        <span>{`${cacheStore.GetString("CreatedOnDLabel")} : ${moment(ac.CreatedDate).format("YYYY/MM/DD")} - `}</span>
                        <span>{limitTextLength(ac.Subject, 30)}</span>
                    </a>
                </div>
            );
        });
    }

    private handleClose(): void {
        this.props.handleClose && this.props.handleClose();
    }
}

export { AttachedCommunicationsPopup };
